const CHAKRA_DATA = {
  "root": {
    name: "Root (Muladhara : मूलाधार) - 🔴 Red",
    color: "#d63031",
    img: "/images/chakras/root.gif",
    description_en: `
The Root Chakra, or Muladhara, is the foundation of the entire chakra system. Located at the base of the spine, it is the seat of security, survival, and grounding. A balanced Muladhara helps you feel stable, safe, and deeply connected to the Earth. Spiritually, it anchors the soul in the physical world, providing a foundation for all higher consciousness.

This chakra governs family, financial security, physical health, and resilience to life's challenges. When balanced, Muladhara brings discipline, focus, and trust in the natural flow of life. It gives you the courage to face difficulties, a sense of belonging, and stability in everyday life. Without a strong root, higher chakras cannot function optimally.

Energy in the Root Chakra manifests as vitality and strength in both mind and body. Meditation and grounding exercises help stabilize it. Walking barefoot on natural surfaces, practicing grounding yoga poses, or visualizing red light at the base of the spine nurtures its energy. Connecting to nature and feeling your physical body also strengthen Muladhara.
`,

description_hi: `
मूलाधार चक्र, जिसे Root Chakra भी कहा जाता है, सम्पूर्ण चक्र प्रणाली की नींव है। यह रीढ़ की हड्डी के आधार पर स्थित होता है और सुरक्षा, अस्तित्व और स्थिरता का स्थान है। जब मूलाधार संतुलित होता है, तो व्यक्ति स्थिर, सुरक्षित और पृथ्वी से गहराई से जुड़ा हुआ महसूस करता है। आध्यात्मिक रूप से यह आत्मा को भौतिक संसार में स्थिर करता है और उच्च चेतना के लिए आधार प्रदान करता है।

यह चक्र परिवार, आर्थिक सुरक्षा, शारीरिक स्वास्थ्य और जीवन की चुनौतियों का सामना करने की क्षमता को नियंत्रित करता है। संतुलित मूलाधार अनुशासन, ध्यान और जीवन के प्राकृतिक प्रवाह में विश्वास लाता है। यह कठिनाइयों का सामना करने का साहस, जीवन में स्थिरता और संबंधों में मजबूती प्रदान करता है। यदि मूलाधार कमजोर है, तो ऊपरी चक्र सही तरह से कार्य नहीं कर सकते।

मूलाधार की ऊर्जा मन और शरीर दोनों में शक्ति और जीवंतता के रूप में प्रकट होती है। ध्यान और ग्राउंडिंग अभ्यास इसे स्थिर करते हैं। प्राकृतिक सतहों पर नंगे पैर चलना, ग्राउंडिंग योगासन करना या रीढ़ के आधार में लाल प्रकाश की कल्पना करना इसकी ऊर्जा को पोषित करता है। प्रकृति से जुड़ना और अपने शारीरिक शरीर को महसूस करना भी इसे मजबूत करता है।
    `,
    details: {
      position: "Base of the spine",
      color: "Red",
      element: "Earth",
      relatedTo: "Survival, grounding, stability, financial security",
      dimension: "1st Dimension - Physical existence and survival",
      whyActivate: `
Activation of Muladhara lays the foundation for higher spiritual growth. Without grounding, all spiritual practices feel unstable. Strengthening the Root Chakra cultivates courage, trust in life, and the ability to withstand challenges.


मूलाधार चक्र का सक्रियण उच्चतर आध्यात्मिक विकास की नींव रखता है। यदि स्थिरता न हो, तो साधना अस्थिर होती है। इस चक्र को मजबूत करने से जीवन में विश्वास, साहस और कठिनाइयों का सामना करने की क्षमता विकसित होती है।
      `
    },
    imbalance: [
      "Anxiety, insecurity, or fear",
      "Lower back pain or leg issues",
      "Financial instability",
      "Feeling disconnected from family or life",
      "Over-attachment to material possessions"
    ],
    balance: [
      "Walking barefoot on earth (earthing)",
      "Yoga poses: Mountain Pose, Tree Pose",
      "Grounding meditation",
      "Crystals: Hematite, Garnet, Black Tourmaline",
      "Affirmations: 'I am safe, secure, and grounded.'"
    ],
    affirmations: [
      "I am deeply rooted and supported by the universe.",
      "I trust the flow of life and feel secure.",
      "I am grounded, stable, and strong in body and mind."
    ]
  },

  "sacral": {
    name: "Sacral (Svadhisthana : स्वाधिष्ठान) - 🟠 Orange",
    color: "#e17055",
    img: "/images/chakras/sacral.gif",
    description_en: `
The Sacral Chakra, Svadhisthana, is located in the lower abdomen below the navel. It governs creativity, emotions, relationships, and sensuality. When balanced, it brings joy, passion, and emotional equilibrium. This chakra is the seat of flow, allowing adaptation to life’s changes and expressing feelings freely.

Spiritually, Svadhisthana is the center of pleasure, creativity, and connection. It empowers you to explore relationships, enjoy life fully, and harness creative energy in art, music, and communication. A balanced sacral chakra encourages emotional healing, intimacy, and embracing desires with awareness.

Energy imbalances manifest as emotional instability, creative blocks, or difficulties in relationships. Healing practices include dancing, painting, water meditations, and yoga poses that activate the lower abdomen. Working with carnelian or moonstone enhances flow and joy.
`,
description_hi: `
स्वाधिष्ठान चक्र, Sacral Chakra, नाभि के नीचे निचले पेट में स्थित होता है। यह रचनात्मकता, भावनाओं, संबंधों और कामुकता को नियंत्रित करता है। जब यह संतुलित होता है, तो व्यक्ति आनंद, उत्साह और भावनात्मक संतुलन अनुभव करता है। यह चक्र जीवन के परिवर्तन के अनुसार ढलने और भावनाओं को स्वतंत्र रूप से व्यक्त करने की क्षमता देता है।

आध्यात्मिक रूप से स्वाधिष्ठान सुख, रचनात्मकता और संबंध का केंद्र है। यह आपको संबंधों का अनुभव करने, जीवन का पूर्ण आनंद लेने और कला, संगीत और संचार में सृजनात्मक ऊर्जा का उपयोग करने का सामर्थ्य देता है। संतुलित स्वाधिष्ठान भावनात्मक उपचार, अंतरंगता और जागरूक इच्छा का समर्थन करता है।

ऊर्जा असंतुलन के कारण भावनात्मक अस्थिरता, रचनात्मक अवरोध या संबंधों में कठिनाई होती है। उपचारात्मक अभ्यास में नृत्य, चित्रकला, जल ध्यान और निचले पेट को सक्रिय करने वाले योगासन शामिल हैं। कार्नेलियन या मूनस्टोन जैसे क्रिस्टल आनंद और प्रवाह को बढ़ाते हैं।
    `,
     details: {
      position: "Lower abdomen (below the navel)",
      color: "Orange",
      element: "Water",
      relatedTo: "Creativity, emotions, relationships, sensuality",
      dimension: "2nd Dimension - Emotions and creativity",
      whyActivate: "Activation allows free flow of emotions and creative expression. It heals guilt, enhances joy, and strengthens intimacy and pleasure. : सक्रियण रचनात्मकता और भावनाओं के प्रवाह को मुक्त करता है। यह अपराधबोध को कम करता है, आनंद बढ़ाता है और अंतरंगता तथा सुख को सशक्त करता है।"
    },
    imbalance: [
      "Reproductive or sexual health issues",
      "Mood swings or emotional instability",
      "Creativity blocks or lack of passion",
      "Suppressed emotions or guilt",
      "Difficulty in relationships"
    ],
    balance: [
      "Engage in creative activities: painting, dance, music",
      "Water meditation and rituals",
      "Yoga: Bound Angle Pose, Cobra Pose",
      "Crystals: Carnelian, Moonstone",
      "Affirmations: 'I embrace creativity and flow with joy.'"
    ],
    affirmations: [
      "I honor my emotions and creative expression.",
      "I allow joy and passion to flow freely.",
      "I am connected to the pleasure and creativity of life."
    ]
  },

  "solar-plexus": {
    name: "Solar Plexus (Manipura : मणिपुर) - 🟡 Yellow",
    color: "#fdcb6e",
    img: "/images/chakras/solar-plexus.gif",
    description_en: `
The Solar Plexus Chakra, Manipura, sits above the navel in the stomach area. It is the center of personal power, will, and confidence. A balanced chakra empowers action, courage, and self-esteem. It is the seat of the fire that drives transformation and personal growth.

Spiritually, Manipura fuels determination, focus, and manifestation. It governs energy, digestion, and transformation of desire into action. When open, it radiates confidence, discipline, and vitality, making one capable of achieving goals and asserting personal boundaries.

Blockages manifest as low self-esteem, anger, fatigue, or control issues. Practices like core-strengthening yoga, fire visualizations, and breathwork help restore balance. Citrine and tiger’s eye crystals support confidence and personal power.
`,
description_hi: `
मणिपुर चक्र, Solar Plexus Chakra, नाभि के ऊपर पेट में स्थित है। यह व्यक्तिगत शक्ति, इच्छाशक्ति और आत्मविश्वास का केंद्र है। जब यह संतुलित होता है, तो यह कार्यक्षमता, साहस और आत्म-सम्मान प्रदान करता है। यह परिवर्तन और व्यक्तिगत विकास की आंतरिक अग्नि का केंद्र है।

आध्यात्मिक रूप से मणिपुर संकल्प, ध्यान और इच्छाओं को क्रियान्वित करने की शक्ति देता है। यह ऊर्जा, पाचन और इच्छाओं को कार्रवाई में बदलने का मार्गदर्शन करता है। खुला मणिपुर आत्मविश्वास, अनुशासन और जीवन ऊर्जा को प्रकट करता है, जिससे व्यक्ति अपने लक्ष्य प्राप्त करने और व्यक्तिगत सीमाओं को स्थापित करने में सक्षम होता है।

अवरोध होने पर आत्म-सम्मान की कमी, क्रोध, थकान या नियंत्रण की समस्याएँ प्रकट होती हैं। कोर स्ट्रेंथिंग योग, अग्नि ध्यान और श्वास अभ्यास संतुलन को पुनर्स्थापित करते हैं। सिट्रीन और टाइगर आई क्रिस्टल आत्मविश्वास और व्यक्तिगत शक्ति को बढ़ाते हैं।
    `,
    details: {
      position: "Stomach area, above the navel",
      color: "Yellow",
      element: "Fire",
      relatedTo: "Confidence, willpower, transformation, vitality",
      dimension: "3rd Dimension - Action and strength",
      whyActivate: "Activation strengthens self-esteem, decision-making, and personal empowerment. : सक्रियण आत्म-सम्मान, निर्णय क्षमता और व्यक्तिगत शक्ति को मजबूत करता है।"
    },
    imbalance: [
      "Digestive problems, fatigue",
      "Low confidence or self-esteem",
      "Anger, fear, control issues",
      "Feeling powerless or directionless"
    ],
    balance: [
      "Breathing exercises and core yoga",
      "Meditation with fire visualization",
      "Crystals: Citrine, Tiger's Eye",
      "Affirmations: 'I am powerful, confident, and full of energy.'"
    ],
    affirmations: [
      "I am confident and empowered in all my actions.",
      "I trust my inner strength and personal power.",
      "I am radiant, courageous, and determined."
    ]
  },

  "heart": {
    name: "Heart (Anahata : हृदय) - 💚 Green",
    color: "#00b894",
    img: "/images/chakras/heart.gif",
    description_en: `
The Heart Chakra, Anahata, is the fourth chakra, located at the center of the chest. It bridges the lower and upper chakras, embodying love, compassion, and forgiveness. A balanced heart chakra radiates unconditional love and emotional harmony, connecting us to others and the Divine.

Spiritually, Anahata dissolves ego boundaries, guiding us from “I” to “We.” It fosters empathy, generosity, and the ability to heal relationships. When open, it allows emotional resilience, joy, and harmonious connection with life.

Blockages manifest as jealousy, grief, inability to trust, or heart/lung issues. Healing includes breathwork, gratitude practice, compassion exercises, green crystals, and loving affirmations.
`,
description_hi: `
हृदय चक्र, अनाहत, चौथा चक्र है और यह छाती के केंद्र में स्थित है। यह निचले और ऊपरी चक्रों को जोड़ता है, प्रेम, करुणा और क्षमा का प्रतिनिधित्व करता है। संतुलित हृदय चक्र बिना शर्त प्रेम और भावनात्मक सामंजस्य को प्रकट करता है, जो हमें दूसरों और दिव्यता से जोड़ता है।

आध्यात्मिक रूप से अनाहत अहंकार की सीमाओं को समाप्त करता है, और हमें "मैं" से "हम" की ओर ले जाता है। यह सहानुभूति, उदारता और रिश्तों को चंगा करने की क्षमता को बढ़ाता है। खुला हृदय भावनात्मक स्थिरता, आनंद और जीवन के साथ सामंजस्यपूर्ण संबंध की अनुमति देता है।

अवरोध ईर्ष्या, शोक, भरोसा न करने की समस्या या हृदय/फेफड़ों की समस्याओं के रूप में प्रकट होते हैं। उपचार में श्वास अभ्यास, कृतज्ञता, करुणा के अभ्यास, हरे क्रिस्टल और प्रेमपूर्ण पुष्टि शामिल हैं।
    `,
    details: {
      position: "Center of chest",
      color: "Green",
      element: "Air",
      relatedTo: "Love, compassion, forgiveness, healing",
      dimension: "4th Dimension - Love and unity",
      whyActivate: "Activation opens the heart to unconditional love, empathy, and harmony in relationships. : सक्रियण हृदय को बिना शर्त प्रेम, सहानुभूति और रिश्तों में सामंजस्य के लिए खोलता है।"
    },
    imbalance: [
      "Heart or lung issues",
      "Loneliness, grief, fear of rejection",
      "Difficulty forgiving or trusting",
      "Jealousy or possessiveness"
    ],
    balance: [
      "Breathwork and meditation",
      "Practicing gratitude and compassion",
      "Crystals: Rose Quartz, Green Aventurine",
      "Affirmations: 'I am open to love and compassion.'"
    ],
    affirmations: [
      "I am open to giving and receiving love.",
      "I forgive myself and others freely.",
      "My heart radiates compassion and peace."
    ]
  },

  "throat": {
    name: "Throat (Vishuddha : विशुद्ध) - 🔵 Blue",
    color: "#74b9ff",
    img: "/images/chakras/throat.gif",
    description_en: `
The Throat Chakra, Vishuddha, governs communication, truth, and authentic expression. Located at the throat, it allows clear speaking, deep listening, and alignment of words with inner wisdom. Balanced Vishuddha fosters eloquence, confidence, and creativity in expression.

Spiritually, it connects heart and mind, enabling wisdom and love to manifest through speech. Chanting, singing, and journaling are effective practices. An open throat chakra supports clarity, honesty, and spiritual communication.

Blockages result in fear of speaking, dishonesty, or throat/thyroid issues. Healing includes vocal expression, journaling, blue crystals, and affirmations.
`,
description_hi: `
विशुद्ध (कंठ) चक्र, संचार, सत्य और वास्तविक अभिव्यक्ति को नियंत्रित करता है। गले में स्थित यह स्पष्ट बोलने, गहराई से सुनने और शब्दों को आंतरिक ज्ञान के साथ संरेखित करने की क्षमता देता है। संतुलित विशुद्ध वाक्पटुता, आत्मविश्वास और रचनात्मक अभिव्यक्ति को बढ़ाता है।

आध्यात्मिक रूप से यह हृदय और मस्तिष्क को जोड़ता है, जिससे ज्ञान और प्रेम वाणी के माध्यम से प्रकट होते हैं। मंत्र-जप, गायन और लेखन प्रभावी अभ्यास हैं। खुला कंठ चक्र स्पष्टता, ईमानदारी और आध्यात्मिक संचार का समर्थन करता है।

अवरोध बोलने के भय, असत्य या गले/थायरॉइड समस्याओं के रूप में प्रकट होते हैं। उपचार में आवाज़ का अभ्यास, लेखन, नीले क्रिस्टल और पुष्टि शामिल हैं।
    `,
    details: {
      position: "Throat",
      color: "Blue",
      element: "Ether / Sound",
      relatedTo: "Communication, honesty, expression",
      dimension: "5th Dimension - Expression and truth",
      whyActivate: "Activation allows clear, authentic self-expression and deep listening. : सक्रियण स्पष्ट, प्रामाणिक आत्म-अभिव्यक्ति और गहन श्रवण की अनुमति देता है।"
    },
    imbalance: [
      "Fear of speaking truth",
      "Thyroid issues, sore throat",
      "Dishonesty or shyness",
      "Difficulty expressing feelings"
    ],
    balance: [
      "Chanting and singing",
      "Journaling thoughts and feelings",
      "Crystals: Turquoise, Aquamarine",
      "Affirmations: 'I express my truth freely and lovingly.'"
    ],
    affirmations: [
      "I speak my truth with clarity and confidence.",
      "My voice is a vessel of wisdom and love.",
      "I communicate openly and authentically."
    ]
  },

  "third-eye": {
    name: "Third Eye (Ajna : आज्ञा) - 🟣 Indigo",
    color: "#6c5ce7",
    img: "/images/chakras/third-eye.gif",
    description_en: `
The Third Eye Chakra, Ajna, located between the eyebrows, is the seat of intuition, insight, and higher wisdom. It is the inner eye that perceives beyond the physical, granting clarity, understanding, and spiritual vision.

A balanced Ajna enhances intuition, foresight, and the ability to perceive underlying truths. It connects intellect with intuition, allowing dreams, visions, and archetypal understanding to guide life with clarity and purpose.

Blockages manifest as confusion, lack of clarity, overactive imagination, or headaches. Meditation, visualization, mindfulness, and indigo crystals help restore balance and expand perception.
`,
description_hi: `
आज्ञा चक्र, तीसरी आँख, भौंहों के बीच स्थित है और यह अंतर्ज्ञान, अंतर्दृष्टि और उच्च ज्ञान का स्थान है। यह आंतरिक आँख है जो भौतिक से परे देखती है और स्पष्टता, समझ और आध्यात्मिक दृष्टि प्रदान करती है।

संतुलित आज्ञा अंतर्ज्ञान, पूर्वदृष्टि और गहरे सत्य को समझने की क्षमता को बढ़ाता है। यह बुद्धि और अंतर्ज्ञान को जोड़ता है, जिससे सपनों, दृष्टियों और प्रतीकों के माध्यम से जीवन स्पष्टता और उद्देश्य के साथ निर्देशित होता है।

अवरोध भ्रम, स्पष्टता की कमी, अत्यधिक कल्पना या सिरदर्द के रूप में प्रकट होते हैं। ध्यान, दृश्यावलोकन, सजगता और इंडिगो क्रिस्टल संतुलन और जागरूकता बढ़ाने में मदद करते हैं।
    `,
    details: {
      position: "Between the eyebrows (forehead center)",
      color: "Indigo",
      element: "Light",
      relatedTo: "Intuition, insight, imagination, inner vision",
      dimension: "6th Dimension - Clairvoyance and perception",
      whyActivate: "Activation enhances intuition, insight, and trust in inner guidance. : सक्रियण अंतर्ज्ञान, अंतर्दृष्टि और आंतरिक मार्गदर्शन में विश्वास को बढ़ाता है।"
    },
    imbalance: [
      "Headaches, vision problems",
      "Confusion, lack of clarity",
      "Overactive imagination or delusions",
      "Difficulty making decisions"
    ],
    balance: [
      "Meditation with third eye focus",
      "Visualization exercises",
      "Crystals: Amethyst, Lapis Lazuli",
      "Affirmations: 'I trust my inner wisdom.'"
    ],
    affirmations: [
      "I trust my intuition and inner guidance.",
      "My mind is clear, focused, and insightful.",
      "I perceive truth with clarity and wisdom."
    ]
  },

  "crown": {
    name: "Crown (Sahasrara : सहस्रार) - ⚪ Violet / White",
    color: "#a29bfe",
    img: "/images/chakras/crown.gif",
    description_en: `
The Crown Chakra, Sahasrara, is the seventh and highest chakra, located at the top of the head. It represents spiritual connection, enlightenment, and unity with the Divine. When balanced, it allows access to higher consciousness, wisdom, and a sense of universal oneness.

Spiritually, Sahasrara transcends ego and physical limitations, connecting you to divine energy and cosmic consciousness. It is the gateway to understanding the true nature of reality, pure awareness, and the eternal self. An open crown chakra fosters deep meditation, spiritual insight, and transcendence of worldly attachments.

Imbalances manifest as disconnection from spirit, confusion, materialism, or spiritual arrogance. Practices to balance include meditation, prayer, Reiki, silence, and violet/white crystals such as amethyst or clear quartz. It is nurtured through surrender, gratitude, and selfless service.

Healing and opening the Crown Chakra allows the flow of wisdom, bliss, and divine guidance into life. Regular meditation, contemplation on universal truths, and connecting to higher vibrational energies strengthen Sahasrara, bringing peace, clarity, and spiritual awakening.
`,
description_hi: `
सहस्रार चक्र, Crown Chakra, सातवाँ और सबसे ऊँचा चक्र है, जो सिर के शीर्ष पर स्थित होता है। यह आध्यात्मिक संबंध, प्रबोधन और दिव्यता के साथ एकता का प्रतीक है। जब यह संतुलित होता है, तो यह उच्च चेतना, ज्ञान और सार्वभौमिक एकता की अनुभूति प्रदान करता है।

आध्यात्मिक रूप से सहस्रार अहंकार और भौतिक सीमाओं से परे है, जो आपको दिव्य ऊर्जा और ब्रह्मांडीय चेतना से जोड़ता है। यह वास्तविकता के सच्चे स्वरूप, शुद्ध जागरूकता और अनंत आत्मा को समझने का द्वार है। खुला सहस्रार गहन ध्यान, आध्यात्मिक अंतर्दृष्टि और सांसारिक आसक्तियों से transcendence को प्रोत्साहित करता है।

असंतुलन आध्यात्मिक कटाव, भ्रम, भौतिकवाद या आध्यात्मिक अहंकार के रूप में प्रकट होते हैं। संतुलन के अभ्यास में ध्यान, प्रार्थना, Reiki, मौन और बैंगनी/सफेद क्रिस्टल जैसे अमेथिस्ट या क्लियर क्वार्ट्ज शामिल हैं। इसे समर्पण, कृतज्ञता और निःस्वार्थ सेवा के माध्यम से पोषित किया जाता है।

सहस्रार को चंगा और खोलने से जीवन में ज्ञान, आनंद और दिव्य मार्गदर्शन का प्रवाह होता है। नियमित ध्यान, सार्वभौमिक सत्य पर चिंतन और उच्चतर ऊर्जा से जुड़ाव सहस्रार को मजबूत करता है, जिससे आंतरिक शांति, स्पष्टता और आध्यात्मिक जागृति मिलती है।
    `,
     details: {
      position: "Top of the head",
      color: "Violet / White",
      element: "Cosmic Consciousness",
      relatedTo: "Spirituality, enlightenment, divine connection",
      dimension: "7th Dimension - Transcendence and unity",
      whyActivate: "Activation opens you to higher consciousness, divine guidance, and spiritual awakening. : सक्रियण आपको उच्चतर चेतना, दिव्य मार्गदर्शन और आध्यात्मिक जागृति के लिए खोलता है।"
    },
    imbalance: [
      "Disconnection from spiritual purpose",
      "Confusion, lack of direction",
      "Materialism or spiritual arrogance",
      "Depression, emptiness, or apathy"
    ],
    balance: [
      "Meditation, silent contemplation, prayer",
      "Reiki and energy healing",
      "Crystals: Amethyst, Clear Quartz",
      "Affirmations: 'I am connected to divine wisdom and universal consciousness.'"
    ],
    affirmations: [
      "I am one with the divine and all that is.",
      "I trust the wisdom of the universe and my higher self.",
      "I am open to divine guidance and spiritual awakening."
    ]
  }
};

export default CHAKRA_DATA;
